import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'image' },
    { value: 2, label: 'file' },
    { value: 3, label: 'link' },
    { value: 4, label: 'video' },
    { value: 5, label: 'audio' },
  ],
});
